module.exports = __webpack_public_path__ + "static/sign-cf8b686b294041d0925f4e745b1fabb9.jpg";